var map = {
	"./interface.class": [
		"e8c5",
		"responseAdapter0"
	],
	"./interface.class.js": [
		"e8c5",
		"responseAdapter0"
	],
	"./raw": [
		"494f",
		"responseAdapter2"
	],
	"./raw.js": [
		"494f",
		"responseAdapter2"
	],
	"./saffron": [
		"caf9",
		"responseAdapter4"
	],
	"./saffron.js": [
		"caf9",
		"responseAdapter4"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "d21f";
module.exports = webpackAsyncContext;